import { usePortsGetList } from '@ais-ui/api';
import { shapeToVectorLayer, useLayers } from '@ais-ui/react-openlayers';
import { useEffect, useMemo, useRef } from 'react';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { usePermissions } from '../Permissions/PermissionsProvider';
import { useSettings } from '../Settings/SettingsProvider';

export const PortLayer = () => {
  const { addLayer, isCanvasLoaded } = useLayers();
  const { data: ports } = usePortsGetList();
  const { settings } = useSettings();
  const portsAdded = useRef(false);

  const portGeoJson: GeoJson | null = useMemo(() => {
    if (!ports || !ports?.records || ports.records.length === 0) return null;

    return {
      type: 'FeatureCollection',
      properties: {
        id: 'gatehouse-ports',
        name: 'Ports',
        icon: 'port',
        maxZoom: 6,
      },
      features: ports.records.map((port) => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: port.position.coordinates as number[],
        },
        properties: {
          id: port.id.toString(),
          country: port.country,
          locode: port.locode,
          name: port.name,
          type: 'port',
        },
      })),
    };
  }, [ports]);

  useEffect(() => {
    if (!portGeoJson) return;

    // Ships must be loaded first
    if (!isCanvasLoaded) {
      return;
    }

    if (!settings['ribbonPlugin.settings']?.show_ports) {
      return;
    }

    if (portsAdded.current) return;

    const portLayer = shapeToVectorLayer(portGeoJson);

    portsAdded.current = true;

    addLayer(
      portLayer,
      'Ports',
      false,
      false,
      true,
      portGeoJson.properties,
      portGeoJson.properties.id,
      false,
      true
    );
  }, [isCanvasLoaded, addLayer, portGeoJson]);

  return null;
};
